module.exports = __webpack_public_path__ + "static/media/ic-save.c444e7e1.svg";